export default __webpack_public_path__ + "static/favicon-d81f550dacb50a94baeb4884c596fc48.ico";